<template>
  <section class="routines-section py-5">
    <div class="overlay"></div>
    <div class="container position-relative text-center text-white">
      <h2 class="display-5 fw-bold mb-5 gradient-text animate-fade-down">
        🏋️‍♂️ Nuestras Rutinas
      </h2>

      <!-- Primera fila: 3 cartas -->
      <div class="row g-4 justify-content-center mb-4">
        <div v-for="(routine, index) in routines.slice(0,3)" :key="index" class="col-md-4">
          <div class="card routine-card animate-fade-up" :style="{ animationDelay: (index * 0.2) + 's' }">
            <div class="card-body text-center">
              <i :class="routine.icon" class="routine-icon mb-3"></i>
              <h5 class="card-title fw-bold">{{ routine.name }}</h5>
              <p class="card-text">{{ routine.description }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Segunda fila: 2 cartas centradas -->
      <div class="row g-4 justify-content-center">
        <div v-for="(routine, index) in routines.slice(3)" :key="index+3" class="col-md-4 col-lg-3">
          <div class="card routine-card animate-fade-up" :style="{ animationDelay: ((index+3) * 0.2) + 's' }">
            <div class="card-body text-center">
              <i :class="routine.icon" class="routine-icon mb-3"></i>
              <h5 class="card-title fw-bold">{{ routine.name }}</h5>
              <p class="card-text">{{ routine.description }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
const routines = [
  { name: 'Fuerza', description: 'Rutina para aumentar fuerza y resistencia muscular.', icon: 'fa-solid fa-dumbbell' },
  { name: 'Cardio', description: 'Mejora tu resistencia cardiovascular y quema calorías.', icon: 'fa-solid fa-heart-pulse' },
  { name: 'Flexibilidad', description: 'estiramientos para mejorar movilidad.', icon: 'fa-solid fa-person-praying' },
  { name: 'HIIT', description: 'Entrenamientos de alta intensidad para resultados rápidos.', icon: 'fa-solid fa-bolt' },
  { name: 'Cross Training', description: 'Mezcla de fuerza, cardio y funcional.', icon: 'fa-solid fa-arrows-rotate' }
]
</script>

<style scoped>
.routines-section {
  position: relative;
  min-height: 100vh;
  background: url('@/assets/images/carruzel/gym3.webp') center/cover no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5rem 1rem;
}

.overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0,0,0,0.5);
  z-index: 0;
}

.container.position-relative {
  z-index: 1;
  font-family: 'Open Sans', sans-serif;
}

/* Título animado con gradiente */
h2.gradient-text {
  background: linear-gradient(90deg, #F97316, #FBBF24, #F97316);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: gradientMove 3s infinite linear;
}

/* Cards */
.routine-card {
  background-color: rgba(255,255,255,0.95);
  border-radius: 15px;
  padding: 2rem 1rem;
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.routine-card:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 12px 30px rgba(0,0,0,0.3);
}

/* Íconos Font Awesome */
.routine-icon {
  font-size: 2.8rem;
  color: #F97316;
  transition: transform 0.3s ease, color 0.3s ease;
}
.routine-icon:hover {
  transform: scale(1.3);
  color: #FBBF24;
}

/* Animaciones */
.animate-fade-up {
  opacity: 0;
  transform: translateY(30px);
  animation: fadeUp 0.8s forwards;
}
.animate-fade-down {
  opacity: 0;
  transform: translateY(-20px);
  animation: fadeDown 0.8s forwards;
}

@keyframes fadeUp { to { opacity: 1; transform: translateY(0); } }
@keyframes fadeDown { to { opacity: 1; transform: translateY(0); } }

/* Gradiente animado */
@keyframes gradientMove {
  0% { background-position: 0% }
  100% { background-position: 200% }
}

/* Asegura que las columnas se ajusten para que la card ocupe toda la altura */
.row.g-4.justify-content-center > .col-md-4, 
.row.g-4.justify-content-center > .col-lg-3 {
  display: flex;
}

/* Responsive */
@media (max-width: 992px) {
  .col-md-4 { flex: 0 0 50%; max-width: 50%; }
}
@media (max-width: 768px) {
  .col-md-4, .col-lg-3 { flex: 0 0 100%; max-width: 100%; }
}
</style>

